<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ t('UserProfilePage.myOrders') }}</ion-title>
        <ion-buttons slot="start">
          <ion-back-button default-href="/profile"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true">
      <!-- Loading Data -->
      <div class="spin" v-if="loading">
        <ion-spinner></ion-spinner>
      </div>

      <!-- Data loaded -->
      <ion-grid fixed v-else>
        <ion-list>
          <ion-item v-for="order in orders" :key="order.id" :router-link="{
              name: 'OrderDetailPage',
              params: { id: order.id, passedOrder: JSON.stringify(order) }
            }" button detail>
            <ion-label>
              <h3>
                {{ t('OrderPage.orderNumber') }}#{{ order.id }}
              </h3>
              <p>{{ formatDate(order.createdAt) }}</p>
              <p>{{ t('OrderPage.total') }}HK$ {{ order.totalPrice }}</p>
              <ion-badge :color="getOrderStatusColor(order.status)">
                {{ order.status }}
              </ion-badge>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
// Vue reactivity
import { ref } from 'vue';

// icons
import { add } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonSpinner, IonList, IonItem, IonLabel, IonIcon,
        IonButtons, IonButton, IonBackButton, IonBadge } from '@ionic/vue';

// API services
import OrderService from '@/services/OrderService';

import { utils } from '@/composables/utils';
import { useI18n } from 'vue-i18n';

export default {
  name: 'OrderListPage',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage,
                IonGrid, IonSpinner, IonList, IonItem, IonLabel, IonIcon,
                IonButtons, IonButton, IonBackButton, IonBadge, },
  setup() {
    // 1. declare state variables (ref to make them reactive)
    const loading = ref(true);
    const orders = ref<any>(null);

    // 2. fetch data from API and store data in state variables
    OrderService.getUserOrders().then(res => {
      loading.value = false;
      orders.value = res;
    });

    // methods or filters
    const { t } = useI18n();
    const { getOrderStatusColor, formatDate } = utils();

    // 3. return variables & methods to be used in template HTML
    return {
      t,

      // icons
      add,

      // variables
      loading, orders,

      // methods
      formatDate, getOrderStatusColor,
    }
  }
}
</script>